import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import LockIcon from "@mui/icons-material/Lock";
import ReplyIcon from "@mui/icons-material/Reply";

interface Props {
  variation: "Lock" | "Back";
  onClick?: () => void;
}

const TopRightButton: React.FC<Props> = ({ variation, onClick }) => {
  const icon =
    variation === "Lock" ? (
      <LockIcon sx={{ fontSize: "2.85714286rem" }} />
    ) : (
      <ReplyIcon sx={{ fontSize: "3.57142857rem" }} />
    );
  // const buttonText = variation === 'Lock' ? 'Lock' : 'Back';

  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <Button
      variant="contained"
      sx={{
        position: "fixed",
        top: "5rem",
        right: variation === "Lock" ? "0" : "0",
        width: variation === "Lock" ? "6rem" : "5rem",
        minWidth: variation === "Lock" ? "6rem" : "5rem",
        height: variation === "Lock" ? "5rem" : "4.07142857rem",
        marginRight: variation === "Lock" ? "1.42857143rem" : "0",
        backgroundColor: "#930000",
        "&:hover": {
          backgroundColor: "#930000",
        },
        color: "white",
        borderRadius:
          variation === "Lock"
            ? "1.07142857rem"
            : "1.07142857rem 0 0 1.07142857rem",
        zIndex: "999",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={handleClick}
    >
      {icon}
    </Button>
  );
};

export default TopRightButton;
